import { Link } from 'gatsby';
import React from 'react';

interface KalibrrLogoProps {
  title?: string;
  variant?: 'blue' | 'gray';
}

const KalibrrLogo: React.FC<KalibrrLogoProps> = ({ title = '', variant = 'blue' }) => {
  return (
    <React.Fragment>
      <Link to='/' style={{ display: 'flex', alignItems: 'baseline' }}>
        {variant === 'blue' ? (
          <img style={{ height: '1.8rem' }}
            src='https://static.kalibrr.com/public/new-kalibrr-logos/kalibrr-logotype-blue.__c98bd117__.svg'
            alt='Kalibrr'
          />
        ) : (
          <img style={{ height: '1.8rem' }}
            src='https://static.kalibrr.com/public/new-kalibrr-logos/kalibrr-logotype-darkblue.__9508191c__.svg'
            alt='Kalibrr'
          />
        )}
        {title ? (
          <h1
            style={{
              fontSize: '2.5rem',
              fontWeight: 400,
              marginLeft: '0.5rem',
              marginBottom: '0',
            }}
          >
            {title}
          </h1>
        ) : null}
      </Link>
    </React.Fragment>
  );
};

export default KalibrrLogo;
